export const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test((v || "").trim());

export const normalizeEmail = (v) => (v || "").trim().toLowerCase();
